import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import OpenDashboard from "./OpenDashboard/OpenDashboardMain";
import Header from "./Components/Header";

function App() {
  return (
    <div className="App">
      <Header />
      <BrowserRouter basename="/atmkenya">
        <Routes>
          <Route path="/" element={<OpenDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
